import React, { useState } from 'react';
import {
  Container,
  Typography,
  TextField,
  FormControl,
  InputLabel,
  Select,
  ListItemText,
  Input,
  MenuItem,
  Checkbox,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import clsx from 'clsx';
import { createApiKey } from '../../redux/actions/managementActions';
import { updateUi } from '../../redux/actions/uiActions';
import { useSelector, useDispatch } from 'react-redux';
import { checkValidId } from '../../util/helpers/validation';
import LoadingButton from '../widgets/LoadingButton';
import { useIntl } from 'react-intl';
import { deburr, isObject } from 'lodash';
import { isLoaded } from 'react-redux-firebase';
import { isEmpty } from 'lodash';

const useStyles = makeStyles(({ spacing, container, palette }) => ({
  container: {
    ...container(2),
    marginLeft: 0,
    maxWidth: '650px',
  },
  button: {
    margin: spacing(2, 0, 2, 0),
  },
  title: {
    color: palette.other.grey.dark,
    marginBottom: spacing(2),
  },
  input: {
    marginBottom: spacing(2),
  },
  formControl: {
    width: '100%',
    marginBottom: spacing(2),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 10 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  getContentAnchorEl: () => null,
};

export default function CreateApiKey(props) {
  const [description, setDescription] = useState('');
  const [domains, setDomains] = useState([]);

  const classes = useStyles();
  const dispatch = useDispatch();
  const intl = useIntl();

  const { ui, profile } = useSelector(({ ui, firebase: { profile } }) => ({
    ui,
    profile,
  }));

  const availableDomains = (isLoaded(profile) && profile.authDomains) || [];

  const handleSubmit = (e) => {
    e.preventDefault();

    const error = checkValidId(description);
    if (isObject(error)) {
      dispatch(
        updateUi({
          snackbar: {
            message: error,
            severity: 'error',
            show: true,
          },
        })
      );

      return;
    }

    dispatch(createApiKey({ description, authDomains: domains }));
  };

  return (
    <Container className={classes.container}>
      <form onSubmit={handleSubmit}>
        <Typography variant="h4" className={clsx(classes.title)}>
          {intl.formatMessage({ id: 'createApiKey.title' })}
        </Typography>

        <TextField
          fullWidth
          required
          id="description"
          name="description"
          type="text"
          label={intl.formatMessage({ id: 'createApiKey.input' })}
          value={description}
          onChange={(e) => setDescription(deburr(e.target.value))}
          className={classes.input}
          autoFocus
        />

        {!isEmpty(availableDomains) ? (
          <>
            <FormControl className={classes.formControl}>
              <InputLabel id="authDomains-select-label">
                {intl.formatMessage({ id: 'editApiKeyAuthDom.authDomains' })}
              </InputLabel>
              <Select
                labelId="authDomains-select-label"
                id="authDomains-select"
                multiple
                value={domains}
                onChange={(e) => setDomains(e.target.value)}
                input={<Input />}
                renderValue={(selected) => selected.join(', ')}
                MenuProps={MenuProps}
              >
                {availableDomains.map((domain) => (
                  <MenuItem key={domain} value={domain}>
                    <Checkbox checked={domains.indexOf(domain) > -1} />
                    <ListItemText primary={domain} />
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </>
        ) : (
          <Typography>{intl.formatMessage({ id: 'editApiKeyAuthDom.noDomainsAvailable' })}</Typography>
        )}

        <LoadingButton
          isLoading={ui.loadingButton.isCreateApiKeyLoading}
          content={intl.formatMessage({ id: 'createApiKey.title' })}
          type="submit"
        />
      </form>
    </Container>
  );
}
